import { FunctionComponent, useState, useEffect } from "react";
import {
  LoadingSpinner,
  PageContainer,
  PageTitle,
} from "src/components/generic";
import { TableCheckbox } from "src/components/inputs";
import Table from "src/components/tables/Table";
import { useAuth } from "src/context/AuthContext";
import { ToastStatus, useToast } from "src/context/ToastContext";
import { dynamo } from "src/utils";
import { userTypes } from "src/utils/types";
import { ReferralPartner } from "src/utils/types/UserTypes";

const ReferralPartners: FunctionComponent = () => {
  const columns: string[] = [
    "",
    "ID",
    "Company Name",
    "Representative",
    "Email",
    "Phone",
    "State",
    "Referrals",
    "Joined",
  ];

  const { user } = useAuth();
  const { setToast } = useToast();

  const [referralPartners, setReferralPartners] = useState<ReferralPartner[]>(
    []
  );
  const [selectPartners, setSelectPartners] = useState<string[]>([]);
  const [loading, setLoading] = useState<boolean>(true);

  const toggleSelectedClients = (checked: boolean, email: string) =>
    checked
      ? setSelectPartners([...selectPartners, email])
      : setSelectPartners(
          selectPartners.filter(
            (selectedEmail: string) => selectedEmail !== email
          )
        );

  const checkValidation = (email: string) => selectPartners.includes(email);

  const rows = referralPartners.map((partner: ReferralPartner) => [
    <TableCheckbox
      checked={checkValidation(partner.userInfo.email)}
      data={partner.userInfo.email}
      toggleSelected={toggleSelectedClients}
    />,
    partner.userId,
    partner.userInfo.companyName,
    partner.userInfo.representativeName,
    partner.userInfo.email,
    partner.userInfo.phone,
    partner.userInfo.state,
    partner.metadata.referralCount || 0,
    partner.metadata.createdAt,
  ]);

  const fetchPartners = async () => {
    setLoading(true);
    if (!user) return;

    try {
      const result = await dynamo.fetch.usersByType(
        userTypes.AccountTypes.REFERRAL
      );

      setReferralPartners(result?.users);
    } catch (error: any) {
      setToast({
        message: error?.message || "Failed to Fetch Partners",
        status: ToastStatus.FAIL,
      });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (user) fetchPartners();
  }, [user]);

  if (loading) return <LoadingSpinner />;
  return (
    <PageContainer>
      <PageTitle title="Referral Partners" />
      <Table columns={columns} rows={rows} />
    </PageContainer>
  );
};

export default ReferralPartners;
